import React from 'react';

const CD = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_182"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_182)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#007BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.498 5.23L3.028 6.003L3.308 4.366L2.12 3.206L3.763 2.969L4.498 1.479L5.232 2.969L6.875 3.206L5.685 4.366L5.967 6.002"
        fill="#FFE000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14L21 3V-1L0 10V14Z"
        fill="#F8D800"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16L21 5V1L0 12V16Z"
        fill="#F8D800"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15L21 4V0L0 11V15Z"
        fill="#D00817"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default CD;
